import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-division2",
  "use": "icon-division2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-division2\"><path d=\"M896 320 896 0 64 0l0 320L0 320l0 704 192 0L192 320 128 320 128 64l320 0 0 256L384 320l0 704 192 0L576 320 512 320 512 64l320 0 0 256-64 0 0 704 192 0L960 320 896 320zM128 960 64 960 64 384l64 0L128 960zM512 960 448 960 448 384l64 0L512 960zM896 960l-64 0L832 384l64 0L896 960z\" fill=\"#ffffff\" p-id=\"46264\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol